import './styles.css';
import { formatAddress } from 'utils/wallet';
import { ReactNode, useState } from 'react';
import {
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
  Root,
} from '@radix-ui/react-popover';
import { usePrivy, useWallets } from '@privy-io/react-auth';
import { PowerIcon } from 'assets/icons/Power';

export const WalletDisconnectDropdown = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { logout, user } = usePrivy();
  const { wallets } = useWallets();
  const stopPropagation = (e: React.MouseEvent<Element, MouseEvent>) => {
    e.stopPropagation();
  };

  const address = wallets?.[0]?.address;
  const avatar = user?.twitter?.profilePictureUrl;
  const handleClick = () => logout();

  return (
    <Root open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverPortal>
        <PopoverContent align='end' asChild>
          <div className="walletDisconnectModal" onClick={stopPropagation}>
            <div
              className="coinInfoContainer "
              style={{ paddingLeft: '20px', paddingRight: '20px' }}
            >
              <div className="flex items-center walletDisconnectModal__account-wrapper">
                <div className="walletDisconnectModalImg">
                  <img
                    src={avatar || ''}
                    alt={user?.twitter?.username || 'User'}
                  />
                </div>

                <div className="flex items-start flex-col">
                  <div className="pl-1 walletDisconnectModalTopText  me-2">
                    <span>Connected account</span>
                  </div>
                  <div className="pl-1 walletDisconnectModalBottomText me-2">
                    <span>{address && formatAddress(address)}</span>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
              <div className="walletDisconnectModalDivider me-auto  " />
            </div>

            <div
              onClick={handleClick}
              className="walletDisconnectModalDangerDiv"
            >
              <PowerIcon className="text-[#DB5024] mr-1" />
              <span className="walletDisconnectModalDangerText">
                Disconnect
              </span>
            </div>
          </div>
        </PopoverContent>
      </PopoverPortal>
    </Root>
  );
};
